/* eslint-disable no-magic-numbers, no-bitwise */

function roundToSignificantDigits (number, significants = 3) {
    if (number === 0) {
        return 0
    }
    const trimRatio = Math.pow(10, significants - Math.ceil(Math.log10(Math.abs(number))))
    return Math.round(number * trimRatio) / trimRatio
}


function significantDigits (number) {
    number = Math.abs(String(number).replace(".", ""))
    if (number === 0) {
        return 0
    }
    while (number !== 0 && number % 10 === 0) {
        number /= 10
    }

    return Math.floor(Math.log10(number)) + 1
}


function clampInt255 (value) {
    value &= (value < 0) - 1
    value |= -(value > 255)
    return value & 0xFF
}


export default {
    roundToSignificantDigits,
    significantDigits,
    clampInt255
}
